import { render } from "./data-stock-etc.vue?vue&type=template&id=71119e04"
import script from "./data-stock-etc.vue?vue&type=script&lang=js"
export * from "./data-stock-etc.vue?vue&type=script&lang=js"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__